import { render, staticRenderFns } from "./autoresponderSettings.vue?vue&type=template&id=321b596a&scoped=true&"
import script from "./autoresponderSettings.vue?vue&type=script&lang=js&"
export * from "./autoresponderSettings.vue?vue&type=script&lang=js&"
import style0 from "./autoresponderSettings.vue?vue&type=style&index=0&id=321b596a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "321b596a",
  null
  
)

export default component.exports